function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 16"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  height: "16",
  rx: "2",
  width: "24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.76 13.4V7.7h10.15v1.58l-1.17 1.25 1.17 1.26v1.61h-1.87l-1-1.1-.98 1.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.44 12.77V8.32h3.77v1.02h-2.55v.7h2.5v1h-2.5v.7h2.55v1.03z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2 12.77l2.08-2.23-2.08-2.22h1.61l1.28 1.41 1.28-1.41h1.54v.04l-2.04 2.18 2.04 2.17v.06h-1.56l-1.3-1.42-1.28 1.42z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.24 2.63h2.44l.86 1.95V2.63h3.02l.52 1.46.53-1.46h2.3v5.7H11.72z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.7 3.25L12.73 7.7h1.35l.37-.9h2.02l.37.9h1.39l-1.96-4.45zm.17 2.56l.6-1.42.58 1.42z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.21 7.7V3.25h1.9L21.1 6l.99-2.74h1.83v4.44l-1.18.01V4.65L21.62 7.7h-1.07L19.4 4.64V7.7z"
})))));